import { StyleSheet } from 'react-native'
import { corporateColor, grayBorders, placeholderColor, textColor, white } from '../../theme/colors'
import { DOBRA } from '../../theme/fonts'

export const styles = StyleSheet.create({
  container: {
    backgroundColor: 'white',
    borderRadius: 8,
  },
  dropdown: {
    borderColor: grayBorders,
    borderRadius: 8,
    borderWidth: 0.5,
    paddingLeft: 9,
    paddingRight: 3,
    height: 42,
    fontFamily: DOBRA,
  },

  label: {
    fontFamily: DOBRA,
    fontSize: 16,
    fontWeight: '500',
    color: corporateColor,
    lineHeight: 20,
    marginBottom: 8,
  },
  placeholderStyle: {
    fontSize: 16,
    color: placeholderColor,
    fontFamily: DOBRA,
  },
  selectedTextStyle: {
    fontSize: 16,
    color: white,
  },
  iconStyle: {
    width: 24,
    height: 24,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
    color: textColor,
  },
  itemTextStyle: {
    fontSize: 16,
    color: textColor,
    fontFamily: DOBRA,
  },
})
